import { Fragment, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@breathelife/mui';
import { TextInput } from '../Components/TextInput';

export function CustomFieldEditor({
  defaultCustomName,
  defaultCustomProperties,
  onCustomNameChange,
  onCustomNameBlur,
}: {
  defaultCustomName?: string;
  defaultCustomProperties?: Record<string, unknown>;
  onCustomNameChange: (value: string) => void;
  onCustomNameBlur: () => void;
}): ReactElement | null {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Box pb={1}>
        <TextInput
          label={t('admin.questionnaireManagement.custom.customName')}
          onChange={(e) => onCustomNameChange(e.target.value)}
          onBlur={onCustomNameBlur}
          value={defaultCustomName}
        />
      </Box>
      <TextInput
        label={t('admin.questionnaireManagement.custom.customProperties')}
        disabled
        multiline={true}
        value={defaultCustomProperties ? JSON.stringify(defaultCustomProperties) : undefined}
      />
    </Fragment>
  );
}
